// extracted by mini-css-extract-plugin
export var sliderRange = "_or-2";
export var sliderRoot = "_or-0";
export var sliderThumb = "_or-3";
export var sliderTrack = "_or-1";